import {CommonPost} from '../../shared/types';

export const uniquePosts = (state: CommonPost[], posts: CommonPost[]): CommonPost[] => {
    if (!posts || !posts.length) {
        return state;
    }
    // Quick optimization, don't try to merge in edits just skip repeat items so we
    // don't trigger updates in cards if we didn't get new items
    const newBlogPosts = posts.reduce((acc: CommonPost[], feedItem: CommonPost) => {
        if (!state.find(x => x.id === feedItem.id)) {
            acc.push(feedItem);
        }
        return acc;
    }, []);

    return newBlogPosts.length ? [...state, ...newBlogPosts] : state;
};
